import { SharedErrorCode } from '../../../shared';
export class BadPaginationParamatersError extends Error {
    constructor(message) {
        super(message);
        this.code = SharedErrorCode.BadPaginationParams;
        Object.setPrototypeOf(this, BadPaginationParamatersError.prototype);
    }
}
